import { LoadableLazy } from '@confluence/loadable';

export type { AnalyticsDialogProps } from './AnalyticsDialog';

export const LazyAnalyticsDialog = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AnalyticsDialog" */ './AnalyticsDialog'))
			.AnalyticsDialog,
});
